import angular from 'angular';
import kformUtils from '../../utils/kform-utils';
import template from './kid.html';
import KidComponent from './kid.component';

const kidConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('kid', {
		title:      'KID',
		template,
		group:      'advanced',
		children:   false,
		selectable: true,
		settings:   new KidComponent(),
		icon:       'fa fa-id-card-o',
		views:      [
			{
				name:     'Display',
				template: 'kform/components/kid/display.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/common/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
		controller: /* @ngInject */ (/** @type {any} */ $scope) => {
			if ($scope.options && $scope.options.building) {
				return;
			}

			if ($scope.component && !$scope.component.options.button) {
				$scope.component.options.button = '';
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};
		},
	});
};

export default angular.module('app').config(kidConfig);
